export const menData = [{
        "id": "1",
        "product": "Menswear",
        "image": "/assets/MenWear/1.jpg",
        "type": "T-Shirt",
        "brand": "Nike",
        "model": "Sporty Tee",
        "price": "29.99",
        "category": "Clothing",
        "description": "A comfortable and stylish sporty t-shirt with moisture-wicking fabric."
    },
    {
        "id": "2",
        "product": "Menswear",
        "image": "/assets/MenWear/2.jpg",
        "type": "Dress Shirt",
        "brand": "Calvin Klein",
        "model": "ClassicFit",
        "price": "49.99",
        "category": "Clothing",
        "description": "A classic fit dress shirt made from high-quality fabric, suitable for formal occasions."
    },
    {
        "id": "3",
        "product": "Menswear",
        "image": "/assets/MenWear/3.jpg",
        "type": "Jeans",
        "brand": "Levi's",
        "model": "511 Slim Fit",
        "price": "59.50",
        "category": "Clothing",
        "description": "Slim fit jeans with a modern look, perfect for casual outings."
    },
    {
        "id": "4",
        "product": "Menswear",
        "image": "/assets/MenWear/4.jpg",
        "type": "Polo Shirt",
        "brand": "Ralph Lauren",
        "model": "Signature Polo",
        "price": "69.00",
        "category": "Clothing",
        "description": "A classic polo shirt with the iconic Ralph Lauren logo, ideal for a refined casual look."
    },
    {
        "id": "5",
        "product": "Menswear",
        "image": "/assets/MenWear/5.jpg",
        "type": "Jacket",
        "brand": "The North Face",
        "model": "Apex Bionic",
        "price": "129.99",
        "category": "Clothing",
        "description": "A versatile softshell jacket designed for outdoor activities and everyday wear."
    },
    {
        "id": "6",
        "product": "Menswear",
        "image": "/assets/MenWear/6.jpg",
        "type": "Shorts",
        "brand": "Under Armour",
        "model": "Tech Mesh Shorts",
        "price": "34.99",
        "category": "Clothing",
        "description": "Lightweight and breathable mesh shorts for workouts and active lifestyles."
    },
    {
        "id": "7",
        "product": "Menswear",
        "image": "/assets/MenWear/7.jpg",
        "type": "Sweater",
        "brand": "Tommy Hilfiger",
        "model": "Crewneck Sweater",
        "price": "79.50",
        "category": "Clothing",
        "description": "A classic crewneck sweater made from soft and comfortable materials."
    },
    {
        "id": "8",
        "product": "Menswear",
        "image": "/assets/MenWear/8.jpg",
        "type": "Suit",
        "brand": "Hugo Boss",
        "model": "ModernFit Suit",
        "price": "499.00",
        "category": "Clothing",
        "description": "A modern-fit suit crafted with attention to detail, perfect for formal occasions."
    },
    {
        "id": "9",
        "product": "Menswear",
        "image": "/assets/MenWear/9.jpg",
        "type": "Hoodie",
        "brand": "Adidas",
        "model": "Essentials Hoodie",
        "price": "44.99",
        "category": "Clothing",
        "description": "A comfortable and stylish hoodie with the Adidas logo, suitable for everyday wear."
    },
    {
        "id": "10",
        "product": "Menswear",
        "image": "/assets/MenWear/10.jpg",
        "type": "Chinos",
        "brand": "Dockers",
        "model": "Alpha Khaki",
        "price": "39.99",
        "category": "Clothing",
        "description": "Versatile chino pants with a modern slim fit, suitable for casual and semi-formal occasions."
    },
    {
        "id": "11",
        "product": "Menswear",
        "image": "/assets/MenWear/11.jpg",
        "type": "Swim Trunks",
        "brand": "Speedo",
        "model": "Endurance+ Swim Trunks",
        "price": "29.50",
        "category": "Clothing",
        "description": "Durable and comfortable swim trunks designed for performance and comfort in the water."
    },
    {
        "id": "12",
        "product": "Menswear",
        "image": "/assets/MenWear/12.jpg",
        "type": "Blazer",
        "brand": "Brothers",
        "model": "Classic Blazer",
        "price": "189.00",
        "category": "Clothing",
        "description": "A timeless classic blazer suitable for both professional and smart-casual looks."
    }
]